/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
const OPTICAL_TIMESERIES_WORKFLOW_AREA = {
    type: "FeatureCollection",
    features: [
        {
            type: "Feature",
            properties: {
                areaName: "Area 1",
            },
            geometry: {
                type: "Polygon",
                coordinates: [
                    [
                        [-3.1805419921874996, 16.204124989730673],
                        [-1.6644287109375, 16.204124989730673],
                        [-1.6644287109375, 17.13554114256562],
                        [-3.1805419921874996, 17.13554114256562],
                        [-3.1805419921874996, 16.204124989730673],
                    ],
                ],
            },
        },
    ],
};

export default OPTICAL_TIMESERIES_WORKFLOW_AREA;
